
function Sobre () {
    return (
    <div>
        Página Sobre
    </div>
    )
}

export default Sobre